import { initFirebase } from '../firebase'
import { collection, getDocs, getCountFromServer, query, orderBy, startAfter, limit } from 'firebase/firestore'

const { db } = initFirebase()

// Speech-to-text (ElevenLabs Scribe) events. Unlike content feedback this is a
// flat, indexed collection, so it is queried directly with pagination — no scan.

function num(v) {
  if (typeof v === 'number') return v
  if (v == null) return 0
  const n = Number(v)
  return isNaN(n) ? 0 : n
}

function toMs(v) {
  if (!v) return 0
  if (typeof v === 'object' && typeof v.toMillis === 'function') return v.toMillis()
  if (typeof v === 'object' && v.seconds) return v.seconds * 1000
  const t = new Date(v).getTime()
  return isNaN(t) ? 0 : t
}

export class FirebaseTranscriptionService {
  async getCount() {
    try {
      const snap = await getCountFromServer(collection(db, 'transcriptions'))
      return snap.data().count
    } catch (e) {
      console.error('transcriptions count failed', e)
      return 0
    }
  }

  // Returns one page newest-first. Pass the previous page's `cursor` to continue.
  async getPage(pageSize = 100, cursor = null) {
    const col = collection(db, 'transcriptions')
    const q = cursor
      ? query(col, orderBy('createdAt', 'desc'), startAfter(cursor), limit(pageSize))
      : query(col, orderBy('createdAt', 'desc'), limit(pageSize))
    const snap = await getDocs(q)
    return {
      items: snap.docs.map(d => this._toEntry(d)),
      cursor: snap.docs.length ? snap.docs[snap.docs.length - 1] : null,
      hasMore: snap.size === pageSize
    }
  }

  _toEntry(docSnap) {
    const d = docSnap.data()
    return {
      id: docSnap.id,
      text: d.text || '',
      userId: d.userId || '',
      language: d.language_code || '',
      languageProbability: num(d.language_probability),
      model: d.model_id || '',
      mimeType: d.mimeType || '',
      durationSeconds: num(d.durationSeconds),
      audioBytes: num(d.audioBytes),
      cost: num(d.cost),
      apiMs: num(d.apiMs),
      ratePerHour: num(d.ratePerHour),
      audioUrl: d.audioUrl || '',
      audioPath: d.audioPath || '',
      timestampMs: toMs(d.createdAt) || toMs(d.timestamp)
    }
  }
}
